import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import Guide from "@/pages/guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuy-spreadsheet",
    element: <Article />,
  },
  {
    path: "/guides/:slug",
    element: <Guide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;